/**
 * Main shell (`AppShellLayout`) is full-bleed horizontally (no default px) so routes like profiles
 * can use the full column. Some list/dashboard UIs expect a small horizontal inset like the old
 * Mantine `Container` padding.
 *
 * **When to add a prefix:** the page’s content feels glued to the viewport edges on desktop/mobile
 * and the design is not intentionally edge-to-edge. Add the pathname prefix here — do not
 * reintroduce global shell padding for every route.
 */
export const MAIN_CONTENT_HORIZONTAL_GUTTER_PX = 16

export function pathnameUsesMainContentHorizontalGutter (pathname: string): boolean {
  if (pathname.startsWith('/gun-vault')) return true
  if (pathname.startsWith('/builds')) return true
  if (pathname.startsWith('/parts-bin')) return true
  if (pathname.startsWith('/parts/')) return true
  return false
}
